import { useSprintQueryClient } from "sprint-common-web";

import { CreateMovieVersionRequest } from "../../../content/movie/api/CreateMovieVersionRequest";
import { useAssetsManageMovieApi } from "../../../content/movie/api/useAssetsManageMovieApi";
import { CreateEpisodeVersionRequest } from "../../../content/tv-series/api/CreateEpisodeVersionRequest";
import { useAssetsManageTvSeriesApi } from "../../../content/tv-series/api/useAssetsManageTvSeriesApi";
import { MovieQueryKey } from "../../data/data-hooks/content/keys/MovieQueryKey";
import { TvSeriesQueryKey } from "../../data/data-hooks/content/keys/TvSeriesQueryKey";

export const useContentVersion = () => {
    const {
        validateCreateEpisodeVersion,
        createEpisodeVersion: createEpisodeContentVersion
    } = useAssetsManageTvSeriesApi();
    const { validateCreateMovieVersion, createMovieVersion: createMovieContentVersion } = useAssetsManageMovieApi();

    const sprintQueryClient = useSprintQueryClient();

    const createMovieVersion = async (createMovieVersionRequest: CreateMovieVersionRequest, movieId: string) => {
        return createMovieContentVersion(createMovieVersionRequest, movieId).finally(async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [MovieQueryKey.MovieDetails, movieId]
            });
        });
    };

    const createEpisodeVersion = async (
        createEpisodeVersionRequest: CreateEpisodeVersionRequest,
        episodeId: string
    ) => {
        return createEpisodeContentVersion(createEpisodeVersionRequest, episodeId).finally(async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [TvSeriesQueryKey.TvSeriesDetails, episodeId]
            });
        });
    };

    return {
        createMovieVersion,
        createEpisodeVersion,
        validateCreateMovieVersion,
        validateCreateEpisodeVersion
    };
};
